import React, { useState, useEffect } from "react";
import logo from "./assets/logo.png";

function App() {
  const [batteryKwh, setBatteryKwh] = useState(14.33);
  const [batteryQty, setBatteryQty] = useState(1);
  const [dod, setDod] = useState(90);
  const [loadValue, setLoadValue] = useState(1000);
  const [loadUnit, setLoadUnit] = useState("W");
  const [currentTime, setCurrentTime] = useState(new Date());

  /* Update South Africa time */
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);
    return () => clearInterval(timer);
  }, []);

  /* Calculations */
  const totalCapacity = batteryKwh * batteryQty;
  const usableCapacity = totalCapacity * (dod / 100);

  const loadKw =
    loadUnit === "W" ? loadValue / 1000 : loadValue;

  const runtimeHours =
    loadKw > 0 ? usableCapacity / loadKw : 0;

  const runtimeH = Math.floor(runtimeHours);
  const runtimeM = Math.round((runtimeHours - runtimeH) * 60);

  const stopTime = new Date(
    currentTime.getTime() + runtimeHours * 60 * 60 * 1000
  );

  const formatTime = (date) =>
    date.toLocaleTimeString("en-ZA", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    });

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <img src={logo} alt="Bevonkte Projects Logo" style={styles.logo} />
        <h2>Bevonkte Battery Calculator</h2>
        <p style={styles.sub}>
          Professional real-world battery estimation
        </p>
      </div>

      {/* Time */}
      <div style={styles.timeBox}>
        <strong>Current Time (South Africa):</strong>{" "}
        {formatTime(currentTime)}
      </div>

      {/* Battery size */}
      <label style={styles.label}>
        Battery Capacity (kWh)
        <span style={styles.help}>
          Size of a single battery (e.g. 5, 10, 14.33)
        </span>
      </label>
      <input
        type="number"
        value={batteryKwh}
        onChange={(e) => setBatteryKwh(e.target.value)}
        style={styles.input}
      />

      {/* Quantity */}
      <label style={styles.label}>
        Number of Batteries
        <span style={styles.help}>
          Total identical batteries in the bank
        </span>
      </label>
      <input
        type="number"
        value={batteryQty}
        min="1"
        onChange={(e) => setBatteryQty(e.target.value)}
        style={styles.input}
      />

      {/* DoD */}
      <label style={styles.label}>
        Depth of Discharge (%)
        <span style={styles.help}>
          Typical lithium batteries use 90%
        </span>
      </label>
      <input
        type="number"
        value={dod}
        onChange={(e) => setDod(e.target.value)}
        style={styles.input}
      />

      {/* Load */}
      <label style={styles.label}>
        Load
        <span style={styles.help}>
          Average power drawn from the battery system
        </span>
      </label>

      <div style={styles.row}>
        <input
          type="number"
          value={loadValue}
          onChange={(e) => setLoadValue(e.target.value)}
          style={styles.input}
        />
        <select
          value={loadUnit}
          onChange={(e) => setLoadUnit(e.target.value)}
          style={styles.select}
        >
          <option value="W">W</option>
          <option value="kW">kW</option>
        </select>
      </div>

      {/* Results */}
      <div style={styles.results}>
        <p>
          <strong>Total Battery Capacity:</strong>{" "}
          {totalCapacity.toFixed(2)} kWh
        </p>
        <p>
          <strong>Usable Capacity (@ {dod}%):</strong>{" "}
          {usableCapacity.toFixed(2)} kWh
        </p>
        <p>
          <strong>Estimated Runtime:</strong>{" "}
          {runtimeH} hours {runtimeM} minutes
        </p>
        <p>
          <strong>Battery will reach DoD at:</strong>{" "}
          {formatTime(stopTime)}
        </p>
      </div>

      {/* Footer */}
      <p style={styles.footer}>
        © Bevonkte Projects • Real-world lithium estimate
      </p>
    </div>
  );
}

const styles = {
  container: {
    maxWidth: 480,
    margin: "auto",
    padding: 20,
    fontFamily: "Arial, sans-serif",
  },
  header: {
    textAlign: "center",
    marginBottom: 20,
  },
  logo: {
    width: 140,
    marginBottom: 10,
  },
  sub: {
    color: "#555",
    fontSize: 14,
  },
  timeBox: {
    textAlign: "center",
    marginBottom: 15,
  },
  label: {
    fontWeight: "bold",
    display: "block",
    marginBottom: 6,
  },
  help: {
    display: "block",
    fontWeight: "normal",
    fontSize: 12,
    color: "#666",
  },
  input: {
    width: "100%",
    padding: 8,
    marginBottom: 12,
    fontSize: 16,
  },
  row: {
    display: "flex",
    gap: 6,
  },
  select: {
    padding: 8,
    fontSize: 16,
  },
  results: {
    background: "#f4f4f4",
    padding: 12,
    borderRadius: 6,
    marginTop: 10,
  },
  footer: {
    textAlign: "center",
    fontSize: 12,
    color: "#777",
    marginTop: 20,
  },
};

export default App;
